import { iam } from 'codemash';
import { Config } from '../configs';
import { makeId } from '../utils/stringHelper';
import { mapApiToDataGuestUser } from './mappers/auth';
import { manageApiUnavailableError } from './error/errors';
import { getGuestRequest, registerGuestRequest } from './client/requests';
import { apiActionChooser } from '../utils/apiActionChooser';

export const getUser = async ({ token }) => {
  try {
    let response;
    let responseObject;

    await apiActionChooser(
      global.localStorage.getItem('v2-company-id'),
      async () => {
        response = await iam.getProfile({
          secretKey: token,
        });

        responseObject = {
          user: mapApiToDataGuestUser({ user: response }),
        };
      },
      async () => {
        response = await getGuestRequest();

        responseObject = {
          user: mapApiToDataGuestUser({
            user: {
              id: response.id,
              displayName: response.id,
            },
          }),
        };
      },
    );

    return responseObject;
  } catch (e) {
    manageApiUnavailableError(e);

    if (Config.SHOW_LOGS) {
      console.log('Error while trying to get user', e);
    }
  }

  return {};
};

export const registerGuest = async () => {
  try {
    let response;
    let responseObject;

    await apiActionChooser(
      global.localStorage.getItem('v2-company-id'),
      async () => {
        response = await iam.registerGuest({
          displayName: makeId(10),
        });

        responseObject = {
          token: response.bearerToken,
          user: mapApiToDataGuestUser({ user: response.result }),
        };
      },
      async () => {
        response = await registerGuestRequest();

        responseObject = {
          token: response.accessToken,
          user: mapApiToDataGuestUser({
            user: {
              id: response.id,
              displayName: response.id,
            },
          }),
        };
      },
    );

    return responseObject;
  } catch (e) {
    manageApiUnavailableError(e);

    if (Config.SHOW_LOGS) {
      console.log('Error while trying to register guest user', e);
    }
  }

  return {};
};
